import type { Client } from '@src/clients/domain/Client';
import { BackButton } from '@src/common/components/button/BackButton';
import { PageLayout } from '@src/common/components/Page';
import { Stack } from '@src/common/components/Stack';
import { MeasurementToggle } from '@src/common/measurements/MeasurementToggle';
import { useMeasurement } from '@src/common/measurements/useMeasurement';
import type { TrailerListing } from '@src/trailer/domain/TrailerList';
import type { TrailerFormSchema } from '@src/trailer/TrailerFormSchema';
import { TrailerPageForm } from '@src/trailer/TrailerPageForm';
import { type SubmitHandler } from 'react-hook-form';
import type * as yup from 'yup';

type Props = {
  client: Client;
  onSubmit: (data: yup.InferType<typeof TrailerFormSchema>) => void;
  isLoading: boolean;
  onCancel: () => void;
  onBack: () => void;
  prefillData?: TrailerListing;
};

export const TrailerPageContent = ({
  client,
  isLoading,
  onSubmit,
  onCancel,
  onBack,
  prefillData,
}: Props) => {
  const { isMetric, setIsMetric } = useMeasurement();

  const submitForm: SubmitHandler<yup.InferType<typeof TrailerFormSchema>> = (
    data,
  ) => {
    onSubmit(data);
  };

  return (
    <PageLayout title={client.name}>
      <Stack alignItems="flex-end">
        <MeasurementToggle isMetric={isMetric} setIsMetric={setIsMetric} />
      </Stack>
      <Stack direction="row">
        <BackButton onClick={onBack} />
      </Stack>
      <TrailerPageForm
        client={client}
        onSubmit={submitForm}
        isLoading={isLoading}
        onCancel={onCancel}
        prefillData={prefillData}
      />
    </PageLayout>
  );
};
